export function filterRoutes(routes: any, permission: any) {
  return routes.filter((itemA: any) => {
    if (itemA.ifHasAuth) {
      return true;
    }
    return permission.some((itemB: any) => itemA.role === itemB.permissionExt);
  });
}
